import { FIELD_LABEL_CLASS, INPUT_CLASS, type SectionProps } from './eventFormShared';

const ERROR_CLASS = 'border-red-300 focus:ring-red-500 focus:border-red-500';

function inputClass(hasError: boolean): string {
    return hasError ? `${INPUT_CLASS} ${ERROR_CLASS}` : INPUT_CLASS;
}

/** Zoom, Google Calendar and .ics - meeting-only. `EventForm` skips rendering
 *  the whole `EventFormSection` around this for an announcement, so there is
 *  no empty "Links" header to fold either - see the `isAnnouncement` guard
 *  where this is composed. */
export function LinksSection({ draft, set, errors, touched, isEdit }: SectionProps) {
    return (
        <div className="flex flex-col gap-4">
            <div>
                <label className={FIELD_LABEL_CLASS}>Zoom join URL {!isEdit && '*'}</label>
                <input
                    type="url"
                    value={draft.zoomUrl}
                    onChange={(e) => set('zoomUrl', e.target.value)}
                    placeholder={
                        isEdit
                            ? 'Leave blank to keep the current link'
                            : 'https://acme.zoom.us/j/123456789'
                    }
                    className={inputClass(touched && Boolean(errors.zoomUrl))}
                />
                {/* No caption: write-only is an API detail, and "blank keeps the
                    current link" is already the placeholder on edit. */}
                {touched && errors.zoomUrl && (
                    <p className="text-red-500 text-xs mt-1">{errors.zoomUrl}</p>
                )}
            </div>
            <div className="grid grid-cols-1 gap-4">
                <div>
                    <label className={FIELD_LABEL_CLASS}>Google Calendar URL (optional)</label>
                    <input
                        type="url"
                        value={draft.googleCalendarUrl}
                        onChange={(e) => set('googleCalendarUrl', e.target.value)}
                        className={INPUT_CLASS}
                    />
                </div>
                <div>
                    <label className={FIELD_LABEL_CLASS}>.ics URL (optional)</label>
                    <input
                        type="url"
                        value={draft.icsUrl}
                        onChange={(e) => set('icsUrl', e.target.value)}
                        className={INPUT_CLASS}
                    />
                </div>
            </div>
        </div>
    );
}
